import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

const titles = [
  'Medical Doctor',
  'Doctor of Osteopathic Medicine',
  'Nurse Practitioner',
  'Physician Assistant',
  'Doctor of Medicine in Dentistry',
  'Doctor of Dental Surgery',
  'Optometrist',
  'Chiropractor',
  'Doctor of Pharmacy',
  'Doctor of Psychology',
  'Licensed Clinical Psychologist',
  'Physical Therapist',
  'Occupational Therapist',
  'Speech Therapist',
  'Registered Nurse',
  'Licensed Vocational Nurse',
  'Registered Dietitian Nutritionist',
  'Licensed Clinical Social Worker',
  'Other health care professionals'
];

const TitleSelect = ({ value = '', onChange, sx }) => {
  return (
    <FormControl fullWidth sx={sx}>
      <InputLabel id="title-label">Title</InputLabel>

      <Select
        labelId="title-label"
        id="title"
        name="title"
        label="Title"
        value={value}
        onChange={onChange}
      >
        <MenuItem value="">
          <em>Title</em>
        </MenuItem>

        {titles.map((title) => (
          <MenuItem key={title} value={title}>
            {title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TitleSelect;